import React from 'react';
import { useTheme } from '@mui/material/styles';
import { Box, Grid, Divider } from '@mui/material';
import { SimTypography } from 'components/SimTypography';

const Values = () => {
	const theme = useTheme();

	return (
		<Box>
			<SimTypography
				variant='h2'
				align={'left'}
				marginLeft={'0.5vw'}
				gutterBottom
				sx={{
					fontWeight: 900,
					color: theme.palette.common.white,
					textTransform: 'uppercase'
				}}>
				Our Values
			</SimTypography>

			<Grid spacing={1}>
				<Grid item xs={6}>
					<Box margin={1}>
						<SimTypography
							variant='h5'
							fontWeight={500}
							color='text.primary'
							align={'left'}
							sx={{
								color: theme.palette.common.white
							}}>
							Selflessness
						</SimTypography>
						<SimTypography
							fontWeight={200}
							component='p'
							align={'left'}
							sx={{
								color: theme.palette.common.white
							}}>
							Embrace & serve the innocent child
							<br />
							with an enthusiastic spirit
						</SimTypography>
					</Box>
				</Grid>

				<Divider
					sx={{ bgcolor: theme.palette.common.white, width: '40vw', marginLeft: '0.5vw', marginRight: '3vw' }}
				/>

				<Grid item xs={6}>
					<Box margin={1}>
						<SimTypography
							variant='h5'
							color='text.primary'
							align={'left'}
							sx={{
								color: theme.palette.common.white
							}}>
							Advocacy
						</SimTypography>
						<SimTypography
							fontWeight={300}
							component='p'
							align={'left'}
							sx={{
								color: theme.palette.common.white
							}}>
							Champion relentlessly for a better world for neuro diverse children
						</SimTypography>
					</Box>
				</Grid>

				<Divider
					sx={{ bgcolor: theme.palette.common.white, width: '40vw', marginLeft: '0.5vw', marginRight: '3vw' }}
				/>

				<Grid item xs={6}>
					<Box margin={1}>
						<SimTypography
							variant='h5'
							color='text.primary'
							align={'left'}
							sx={{
								color: theme.palette.common.white
							}}>
							Excellence
						</SimTypography>

						<SimTypography
							component='p'
							align={'left'}
							sx={{
								color: theme.palette.common.white
							}}>
							Commit to uncompromising quality of care with research & innovation
						</SimTypography>
					</Box>
				</Grid>

				<Divider
					sx={{ bgcolor: theme.palette.common.white, width: '40vw', marginLeft: '0.5vw', marginRight: '3vw' }}
				/>

				<Grid item xs={6}>
					<Box margin={1}>
						<SimTypography
							variant='h5'
							color='text.primary'
							align={'left'}
							sx={{
								color: theme.palette.common.white
							}}>
							Integrity
						</SimTypography>
						<SimTypography
							fontWeight={300}
							component='p'
							align={'left'}
							sx={{
								color: theme.palette.common.white
							}}>
							Build trust through unwavering authenticity and transparency
						</SimTypography>
					</Box>
				</Grid>
			</Grid>
		</Box>
	);
};

export default Values;
